<template>
  <div class="about">
    <div class="aboutContent">
      <h1>About Sahani Decors</h1>
      <div class="contents">
        <div>
          <h2>Who are we</h2>
          <p>
            Sahani Decors is Interior Works and Design Studio, based in Mumbai,
            India, founded by father & son duo Ramasrey Sahani & Sunny Sahani.
          </p>
        </div>

        <div>
          <div>
            <h2>What we do</h2>
            <p>
              With over
              <strong>22 years of work experience</strong> of the residential
              design and development. We understand your personal space and
              people, how people interact with thier personal space. Our
              experience allows us to create residential space that not only
              look beautiful but feel as well. We offer the following.
            </p>
            <div class="numprocess">
              <h3>Residential Design</h3>
              <h3>Hospitally Design</h3>
              <h3>Office Design</h3>
            </div>
            <p>
              Our offer expands from design through complettion of build. Our
              rich connections and ever growing network of expert workers and
              vendors ensure best of quality work, materials, and services.
            </p>
          </div>

          <div>
            <h2>How do we do</h2>
            <p>
              With one eye in past and one in future. We work with you to design
              the space accounding to your needs and our expertise and
              creativity. Our process is as follows
            </p>
            <div class="numprocess">
              <h3>1. Meet & Examine</h3>
              <p>
                We meet examine the premises, take required specifications, and
                agree.
              </p>
              <h3>2. Concept & Prototyping</h3>
              <p>
                We bounce around ideas, create 3D model weherever required for
                you to visualize beforehand.
              </p>
              <h3>3. Develop & Deliver</h3>
              <p>We get the best to build the project, install and deliver.</p>
            </div>
          </div>
        </div>

        <div class="history">
          <h2>History</h2>
          <p>
            Sahani Decors is brain child of Dhiraj Contractors. Our team has
            expertise in the field of residential and commercial Interior design
            and development services dating back to 1998.
          </p>
        </div>

        <div class="windowidea">
          <div>
            <h2>Have an idea?</h2>
            <p>
              Making Living Lovely – Whether you want to re-design your home,
              re-invent your establishment or style your shoot, we are ready for
              you to get in touch. Please email us with your enquiry regarding
              Interior Design, Styling or brand collaboration.
            </p>
            <router-link class="button leanmore" to="/contact">
              <p>lets talk</p>
            </router-link>
          </div>
          <div class="window">
            <img src="../assets/window.svg" alt />
          </div>
        </div>
      </div>
    </div>
    <MyFooter :footer-image="footerImage" />
  </div>
</template>

<script>
import MyFooter from "@/components/MyFooter";
export default {
  name: "About",
  data: function() {
    return {
      footerImage: require("../assets/cupboard.svg")
    };
  },
  components: {
    MyFooter
  }
};
</script>

<style scoped lang="scss">
.about {
  .aboutContent {
    width: 85vw;
    margin: 3rem auto 6rem;
    h1 {
      margin-top: 3rem;
      color: $accentPrimary;
      font-size: 3rem;
    }

    .contents {
      display: flex;
      flex-direction: column;

      @include mediumScreen {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 2rem;
      }

      h2 {
        font-size: 2rem;
        margin-top: 2rem;
      }
      p {
        font-size: 1.3rem;
        text-align: justify;
      }

      ul {
        font-size: 1.3rem;
        font-weight: bold;
        margin-left: 2rem;
      }

      .history {
        grid-row: 1/2;
        grid-column: 2/3;
      }

      .numprocess {
        @include mediumScreen {
          margin-left: 2rem;
        }
      }

      .windowidea {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: right;

        .leanmore {
          margin-top: 1rem;
        }

        .window {
          max-width: 50vw;
          align-self: center;
          display: none;
          @include mediumScreen {
            display: block;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
          }
          img {
            width: 30vw;
          }
        }
      }
    }
  }
}
</style>
